"use strict";

exports.__esModule = true;
exports.getDevice = getDevice;
exports.getDeviceName = getDeviceName;
function getDevice(devices, uuid) {
  for (var i = 0; i < (devices == null ? void 0 : devices.length); i++) {
    var device = devices[i];
    if (device.uuid === uuid) {
      return device;
    }
  }
  return null;
}

/**
 * Returns the devices name or the uuid if unable to find the device in the given list
 */
function getDeviceName(devices, uuid) {
  var device = getDevice(devices, uuid);
  return device ? device.name : uuid;
}